import React, { Component } from "react";
import { Pagination, Loading } from "@alife/next";
import $ from "jquery";
import Offer from "./newUIOffer";
import { connect } from "@alife/tarot";
import goldlog from "@ali/goldlog";
import ClassNames from "classnames";
import Util from "../../util/common";
import AiContainer from "./ai";
import { getAIData } from "../../../service";


window.jplus || (window.jplus = {});
window.jplus.plugin || (window.jplus.plugin = {});
window.jplus.plugin.exp || (window.jplus.plugin.exp = []);

window.jplus.plugin.exp.push({
  config: {
    selector: ".offer_exp",
    visible: "0.3",
    duration: "300",
    propsMap: {
      url: "data-jplus-exp-url",
    },
  },
  expWillRecord: (...obj) => {
    const target = obj[1];
    const targetAttr = obj[2] || "";
    if (targetAttr["data-jplus-exp-url"]) {
      goldlog.record(
        "/btob.wxb.pcsem_exp_pre",
        "EXP",
        `offerReport=${target["data-aplus-report"]}`,
        "GET"
      );
      return obj[0];
    }
  },
});

class List extends Component {
  constructor(opts) {
    super(opts);
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.getFormatIds = this.getFormatIds.bind(this);
  }

  getFormatIds(list) {
    const resultIds =
      list.reduce((ret, item) => {
        ret.push(`${item.offerid}:${item.memberId}`);
        return ret;
      }, []) || [];
    return resultIds.join(",");
  }

  pageChange(current) {
    window.scrollTo(0, 220);
    const { dispatch } = this.props;
    //清空上次数据
    dispatch("offer/resetList");

    dispatch("offer/setParams", {
      beginpage: current,
      asyncreq: 1,
    });
    //设置背景loading
    dispatch("offer/setValues", {
      bodyLoading: true,
      isEnd: false,
    });
    dispatch("offer/getGraphList", {
      beginpage: current,
      asyncreq: 1,
    });

    window.__WPO.log(`turn_page_${pageConfig.keywords}_${current}`, 1);
    goldlog.record(
      "/szyx.pc_sem.turn_page",
      "CLK",
      `keyword=${pageConfig.keywords}&count=${current}`,
      "GET"
    );
  }

  getData() {
    const { dispatch, formParams, isLoading } = this.props;
    if (formParams.asyncreq > 6) {
      return false;
    }
    dispatch("offer/setParams", {
      keyword: pageConfig.keywords,
    });
    if (!isLoading) {
      dispatch("offer/getGraphList");
    }
  }

  async componentDidMount() {
    const self = this;
    const { dispatch, formParams } = this.props;

    //首屏直出
    //console.log(this.props.listOffer, formParams.beginpage);
    if (
      this.props.listOffer &&
      this.props.listOffer.length > 0 &&
      formParams.beginpage == 1
    ) {
      dispatch("offer/setValues", {
        list: this.props.listOffer,
      });
      dispatch("offer/setParams", {
        asyncreq: 2,
      });
      dispatch("offer/setParams", {
        keyword: pageConfig.keywords,
      });
      dispatch("offer/getGraphList");
    }
    
    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      const w_h = $(window).height();
      const _top = $("#offerList").offset().top;
      const _content_h = $("#offerList").height();
      // 调节区 增大
      const _h = 550;
      if (scrollTop + w_h + _h >= _content_h + _top - w_h) {
        const { isEnd } = self.props;
        if (!isEnd) {
          // debugger;
          self.getData();
        }
      }
    });

    //get ai data
    
    // let aiData = await getAIData();
    // console.log('aidata', aiData);
    // if(!!aiData && aiData.tags && aiData.tags.length > 0) {
    //   aiData.type = 'aiCard';
    //   let { list } = this.props;
    //   list.splice(15, 0, aiData);
    //   dispatch("offer/setValues", {
    //     list
    //   });
    // }
   
  }

  componentDidUpdate() {
    window.Light && window.Light.init();
  }

  /*componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;
    const { reqOnlyList } = nextProps;
    if (reqOnlyList && reqOnlyList.length > 0) {
      //回归状态
      dispatch("offer/setReqOnlyList", {
        reqOnlyList: [],
      });
    }
  }*/

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;
    if (this.props.aiData && !this.props.aiData.tags && nextProps.aiData && nextProps.aiData.tags && nextProps.aiData.tags.length > 0 && nextProps.aiData.offer && nextProps.aiData.offer.total > 0 ) {
      //console.log(this.props.list, nextProps.aiData);
      nextProps.aiData.type = 'aiCard';
      let { list } = this.props;
      list.splice(15, 0,  nextProps.aiData);
      dispatch("offer/setValues", {
        list
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch("offer/resetData");
  }

  render() {
    const { list, buyerTags } = this.props;
    const { width = 1190, formParams } = this.props;

    const clswarp = ClassNames({
      bg_gray: true,
      clearfix: true,
      over_hid: true,
      w_1190: width === 1190,
      w_990: width === 990,
      w_1390: width === 1390,
    });

    const cls_list = ClassNames({
      mt20: true,
      over_hide: true,
      w_1210: width === 1190,
      w_1420: width === 1390,
      w_1024: width === 990,
      offer_list: true,
    });
    const { bodyLoading = false } = this.props;
    // const mockInfo = this.props.mkc.mkcInfo || {};

    let sliderFlag = false;
    list.slice(0, 3).map((offer, index) => {
      list[index].showDancingWW = true;
      if (!!offer.mainVideoUrl) {
        list[index].showVideoIcon = true;
      }
      if (!sliderFlag && offer.imgUrlList && offer.imgUrlList.length >= 3) {
        list[index].showImgSlider = true;
        sliderFlag = true;
        return;
      }
    });


    return (
      <div className={clswarp} id="offerList" data-spm="dh_002">
        <Loading tip="" visible={bodyLoading}>
          <div className={cls_list}>
            {list.map((item, index) => {
              if(item.type === 'aiCard') {
                return (
                  <AiContainer
                    data={item}
                  />
                );
              }
              item.isPcSem = true;
              return (
                <Offer
                  key={index}
                  index={parseInt(formParams.beginpage - 1) * 120 + index}
                  data={item}
                  buyerTags={buyerTags}
                  idx={index}
                />
              );
            })}
          </div>
          <div className="txt_center">
            <Pagination
              pageSizeSelector={false}
              current={parseInt(formParams.beginpage)}
              pageSize={120}
              total={50 * 120}
              size="large"
              onChange={this.pageChange}
            />
          </div>
        </Loading>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.offer,
});
export default connect(mapStateToProps)(List);
